import {
  canSubscribeToChannel,
  canSubscribeToChannelByPricingPlan,
} from '@wix/wix-vod-shared/widget';

/**
 * Is video subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @return {Boolean}
 */
export function isSubscriptionButtonVisible({ channel = {} }) {
  return (
    canSubscribeToChannel(channel) ||
    canSubscribeToChannelByPricingPlan(channel)
  );
}
